import { Body, Panel } from '@hover/blueprint';
import { iArrowLeft, iX } from '@hover/icons';
import React from 'react';

import { CardHeader } from 'src/modules/designStudio/components/DesignMenu/CardHeader';
import { usePartner } from 'src/modules/designStudio/hooks';
import { Partner } from 'src/modules/designStudio/providers';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type MenuHeaderProps = {
  headerText: string;
  closeMenu: () => void;
  onBack?: () => void;
  disableDisclaimer?: boolean;
};
export const MenuHeader = ({
  headerText,
  closeMenu,
  onBack,
  disableDisclaimer,
}: MenuHeaderProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  const showJamesHardieProductDisclaimer =
    usePartner() === Partner.JAMES_HARDIE && !disableDisclaimer;
  return (
    <>
      <CardHeader
        headerText={headerText}
        leftActionHandler={onBack}
        leftIcon={onBack === undefined ? undefined : iArrowLeft}
        rightActionHandler={closeMenu}
        rightIcon={iX}
      />
      {showJamesHardieProductDisclaimer && (
        <Panel
          backgroundColor="primary100"
          data-testid="jhProductDisclaimer"
          display="block"
          marginBottom="400"
          paddingBottom="50"
          paddingTop="50"
        >
          <Body float="left" fontSize="200" margin="1em 0.5em 0 0">
            <strong>{t('jamesHardie.note')}: </strong>
          </Body>
          <Body color="neutral600" fontSize="200">
            {t('jamesHardie.productDisclaimer', { url: 'jameshardie.com' })}
          </Body>
        </Panel>
      )}
    </>
  );
};
